import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { PartnerRegistration } from '../../models/organizations.model';
import {
	fetchPartnersClear,
	fetchPartnersStart,
} from '../../state/organizations.actions';
import { selectPartners } from '../../state/organizations.selector';

@Component({
	selector: 'app-partners',
	styleUrls: ['./partners.component.scss'],
	templateUrl: './partners.component.html',
})
export class PartnersComponent implements OnInit, OnDestroy {
	activeFilter: number = 1;
	loading: boolean = true;
	partners: PartnerRegistration[] = [];

	private paramsId: string = '';

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly store: Store,
	) {}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.store.dispatch(fetchPartnersClear());
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id }) => {
			if (id) {
				this.paramsId = id;
			}
		});
		this.store.dispatch(fetchPartnersStart());
		this.store
			.select(selectPartners)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((partners) => {
				if (partners) {
					this.partners = partners;
					this.loading = false;
				}
			});
	}

	onEditPartner(id: string): void {
		if (this.paramsId) {
			this.router.navigateByUrl(
				`organizacoes/${this.paramsId}/parceiros/${id}`,
			);
		}
	}

	shouldDisplayPartner(partner: PartnerRegistration): boolean {
		switch (this.activeFilter) {
			case 2:
				return partner.health_plan;
			case 3:
				return partner.dental_plan;
			default:
				return true;
		}
	}
}
